module.exports = __webpack_public_path__ + "static/media/portfolio8.f3b012a0.png";